<template>
  <div id="app">
    <v-app class="primary" id="inspire">
      <v-main>
        <v-container fluid class="primary fill-height justify-center">
          <router-view/>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>

export default {
  components: {},
  watch: {},
  props: [],
  name: 'template-authorisation',
  data() {
    return {};
  },
  created() {

  },
  methods: {},
};
</script>

<style scoped lang="scss">

</style>
